import { useEffect } from "react";
import { createPortal } from "react-dom";
import TemplateRaport from "./TemplateRaport";

// Cetak raport — dipakai layar terbit trainer (TerbitMurid) dan penampil raport team leader.

// Salinan khusus cetak, dipasang langsung di <body>. Selama terpasang, <html> ditandai
// .rp-mencetak dan saat mencetak hanya salinan ini yang tampil (raport-cetak.css). Di layar
// ia tersembunyi — juga dari pembaca layar, supaya raportnya tak terbaca dua kali.
export function LembarCetak({ isi, tanda }) {
  useEffect(() => {
    document.documentElement.classList.add("rp-mencetak");
    return () => document.documentElement.classList.remove("rp-mencetak");
  }, []);
  return createPortal(
    <div className="rp-cetak-akar" aria-hidden="true">
      <TemplateRaport isi={isi} tanda={tanda} />
    </div>,
    document.body
  );
}

export function cetak(isi) {
  // Judul dokumen = nama berkas bawaan saat "Simpan sebagai PDF".
  const lama = document.title;
  document.title = `Raport ${isi.murid.nama} - ${isi.term.name}`;
  const pulih = () => {
    document.title = lama;
    window.removeEventListener("afterprint", pulih);
  };
  window.addEventListener("afterprint", pulih);
  window.print();
}
